import type { ReactNode } from 'react'
import { useGoBack } from '../telegram/navigation.ts'
import { getTelegramEnv } from '../telegram/sdk.ts'
import { IconBack } from './icons.tsx'

interface ScreenHeaderProps {
  title: ReactNode
  actions?: ReactNode
  small?: boolean
  /** Вложенный экран: вне Telegram показываем кнопку «Назад» на странице. */
  back?: boolean
}

export function ScreenHeader({ title, actions, small, back }: ScreenHeaderProps) {
  const goBack = useGoBack()
  const showBack = back && !getTelegramEnv().native
  return (
    <header className="screen-header">
      {showBack && (
        <button type="button" className="icon-btn icon-btn--back" aria-label="Назад" onClick={goBack}>
          <IconBack size={26} />
        </button>
      )}
      <h1 className={`screen-header__title${small ? ' screen-header__title--sm' : ''}`}>{title}</h1>
      {actions && <div className="screen-header__actions">{actions}</div>}
    </header>
  )
}

/** Обёртка экрана: одна колонка до 720 px, отступы под таббар/нижнюю панель. */
export function Screen({
  root,
  children,
  label,
  className,
}: {
  root?: boolean
  children: ReactNode
  label?: string
  className?: string
}) {
  return (
    <main
      className={['screen', root && 'screen--root', className].filter(Boolean).join(' ')}
      aria-label={label}
    >
      {children}
    </main>
  )
}
